import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CurrencyItem from '../../../../components/CurrencyItem';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import PageHeader from '../../../../components/PageHeader';
import AppConfig from '../../../../config';
import { t } from '../../../../lang';
import { receiveSlice } from '../../../../store/slices/receive';
import './ReceiveAsset.scss';

const { routes } = AppConfig;

const ReceiveAsset = () => {
	const availableCurrencies = useSelector(state => state.app.availableCurrencies);

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const sortedCurrencies = [...availableCurrencies]?.sort((a, b) => (b?.AmountUsd ?? 0) - (a?.AmountUsd ?? 0));

	const onAssetClick = asset => {
		dispatch(receiveSlice.actions.setAsset(asset));
		navigate({ pathname: routes.receiveAddress });
	};

	return (
		<div className='ReceiveAsset'>
			<PageHeader header={'Select asset to receive'} />

			{sortedCurrencies.length > 0 ? (
				<div className='ReceiveAsset-body FormBlock'>
					{sortedCurrencies?.map((currency, index) => (
						<CurrencyItem key={index} currency={currency} onClick={() => onAssetClick(currency)} />
					))}
				</div>
			) : (
				<div className='ReceiveAsset-empty'>
					<div className='ReceiveAsset-empty__box'>
						<Icon type={Icons['EMPTY_BH_PAGE']} width={140} height={140} />
						<div className='ReceiveAsset-empty__small-icon'>
							<Icon type={Icons['ARROW_CIRCLE']} width={48} height={48} />
						</div>
					</div>
					<div className='ReceiveAsset-empty__text'>{t("You don't have any assets available to receive yet.")}</div>
				</div>
			)}
		</div>
	);
};

export default ReceiveAsset;
